/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { useEffect, useState } from 'react'

import { useWeb3Context } from '../contexts/Web3Context'

export const useBlockNumber = () => {
  const { library } = useWeb3Context()

  const [blockNumber, setBlockNumber] = useState<number>(-1)

  useEffect(() => {
    if (!library) return

    const logBlockNumber = (blockNumber: number) => {
      setBlockNumber(blockNumber)
      console.log(`current block number: ${blockNumber}`)
    }

    library.on('block', logBlockNumber)

    return () => {
      library.off('block', logBlockNumber)
    }
  }, [library])

  return blockNumber
}
